// @ts-nocheck
import { scarpaGray800 } from '@habitech/shared';
import styled from 'styled-components';

export const SummaryWrapper = styled.div`
    margin-bottom: 24px;
    .title {
        font-size: 16px;
        font-weight: bold;
        color: ${scarpaGray800};
    }
    .item {
        font-size: 10px;
        color: ${scarpaGray800};
        margin: 8px;
    }
`;

export const ButtonsWrapper = styled.div`
    margin: 0 24px;
    height: 56px;
    display: flex;
    justify-content: center;
    gap: 24px;
    .loader-button {
        width: 100%;
    }
`;
